import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, TitleAndDescription, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import axios from "axios";

export default class ProgramacaoCopia extends Component {
  constructor(props) {
    super(props);
    this.notificar = this.notificar.bind(this);
    this.onChangeInput = this.onChangeInput.bind(this);
    this.abrirPaginaProgramacao = this.abrirPaginaProgramacao.bind(this);
    this.load = this.load.bind(this);

    this.state = {
      dataInicial: new Date(),
      dataFinal: new Date(),
      descricao: "",
      idProgramacaoCopiar: null,
    };
  }

  componentDidMount() {
    this.load();
  }

  load() {
    let idProgramacaoStorage = localStorage.getItem("idProgramacaoCopiar");

    if (idProgramacaoStorage !== null) {
      this.setState({ idProgramacaoCopiar: idProgramacaoStorage }, () => {
      localStorage.removeItem("idProgramacaoCopiar");
      });
    } else {
      this.props.history.push("/home");
    }
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  onChangeInput(tipo, value) {
    this.setState({ [tipo]: value });
  }

  async abrirPaginaProgramacao() {
    if (this.state.descricao === "") {
      this.notificar("warning", "Favor preencher a descrição.");
      return false;
    } else {
      await axios
        .post(`${this.props.getBaseUrlApi()}/programacao/copiar`, {
          idProgramacaoCopiar: this.state.idProgramacaoCopiar,
          dataInicial: this.state.dataInicial,
          dataFinal: this.state.dataFinal,
          desc: this.state.descricao,
        })
        .then((response) => {

          localStorage.setItem(
            "dtini",
            moment(this.state.dataInicial).format("YYYY-MM-DD")
          );
          localStorage.setItem(
            "dtfim",
            moment(this.state.dataFinal).format("YYYY-MM-DD")
          );
          localStorage.setItem("descProgramacao", this.state.descricao);
          localStorage.setItem("actionPage", "editar");
          localStorage.setItem("idProgramacao", response.data.idAgendaNova);
          this.props.history.push("/programacao");
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.notificar(
              "warning",
              "Favor escolher a mesma quantidade de dias para a cópia"
            );
          } if (error.response.status === 401) {
            this.props.logout();
          } else {
            console.log(error);
            this.notificar("error", "Ocorreu uma exceção no servidor.");
          }
        });
    }
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Copiar Programação" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"programacao"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title="Copiar Programação"
                  description="Informe os detalhes da nova agenda"
                /> */}

                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div className="row">
                                  <div className="col-md-4">
                                    <div className="row">
                                      <div className="col-md-12">
                                        <div className="form-group">
                                          <label>Descrição</label>
                                          <input
                                            type="text"
                                            className={`form-control`}
                                            onChange={(e) =>
                                              this.onChangeInput(
                                                "descricao",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-md-3">
                                        <div className="form-group">
                                          <button
                                            className="btn btn-success"
                                            onClick={
                                              this.abrirPaginaProgramacao
                                            }
                                          >
                                            GRAVAR
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="row">
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <label>Data inicial</label>
                                          <DatePicker
                                            selected={this.state.dataInicial}
                                            withPortal
                                            customInput={
                                              <input className="form-control font-size-13" />
                                            }
                                            dateFormat="dd/MM/yyyy"
                                            onChange={(date) =>
                                              this.onChangeInput(
                                                "dataInicial",
                                                date
                                              )
                                            }
                                            locale="pt-BR"
                                          />
                                        </div>
                                      </div>

                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <label>Data final</label>
                                          <DatePicker
                                            selected={this.state.dataFinal}
                                            withPortal
                                            customInput={
                                              <input className="form-control font-size-13" />
                                            }
                                            dateFormat="dd/MM/yyyy"
                                            onChange={(date) =>
                                              this.onChangeInput(
                                                "dataFinal",
                                                date
                                              )
                                            }
                                            locale="pt-BR"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
